<div
  class="relative bg-dark-gray-turquoise color-light border-radius-5 overflow-hidden m-a card-container"
  style="max-width: fit-content">
  <!-- HEADER -->
  <cp-widget-header text="EPC" icon="epc-chart-2" [isAbsolutePosition]="true" />
  <!--  <button pButton class="p-button p-button-primary p-button-outlined small icon-only close-button">-->
  <!--    <shared-icon icon="cross" height="1rem" width="1rem" class="fill-light" />-->
  <!--  </button>-->

  <!-- BODY-->
  <div class="flex-column gap-3 pt-5">
    <div class="pt-4 text-28 bold-800 px-5 text-center">
      Let us help you make {{ propertyName }} more energy efficient
    </div>

    <cp-widget-epc-improvements-carousel [epc]="epc" />

    <div class="text-14 bold-500 px-5 text-center">
      Your mortgage can pay for your home improvements. Talk to your adviser about borrowing more on
      your mortgage that can save you thousands
    </div>

    <div class="m-a pb-5 px-5">
      <button
        pButton
        class="p-button p-button-primary justify-self-center"
        [routerLink]="['/', paths.PLATFORM, paths.platform.EPC, propertyId]">
        Show EPC details
      </button>
    </div>
  </div>
</div>
